import Vue from 'vue'
Vue.mixin({
  methods: {
    // 时间格式化
    CONVERTYODATE (date) {
      // eslint-disable-next-line no-redeclare
      var date = new Date(date)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      var d = date.getDate()
      m = m < 10 ? '0' + m : m // 月份如果小于10，则在前面加一个0
      d = d < 10 ? '0' + d : d // day如果小于10，则在前面加一个0
      return y + '-' + m + '-' + d
    }
  }
})



// WEBPACK FOOTER //
// ./src/mixin/format.js